import { apiClient } from "../../base/ApiClient";

class AuthService {
  async login(username, password) {
    try {
      const response = await apiClient.post('/auth/login/', {
        username,
        password,
      });
      
      const data = response.data;
      
      if (data) {
        localStorage.setItem("userInfo", JSON.stringify(data));
      }
      
      return { success: true, data };
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || "Login failed";
      return { success: false, error: errorMessage };
    }
  }

  logout() {
    localStorage.removeItem("userInfo");
    window.location.href = "/login";
  }

  getUserInfo() {
    try {
      const userInfo = localStorage.getItem("userInfo");
      return userInfo ? JSON.parse(userInfo) : null;
    } catch {
      return null;
    }
  }

  getToken() {
    const userInfo = this.getUserInfo();
    return userInfo?.access || userInfo?.token || null;
  }

  isAuthenticated() {
    return !!this.getToken();
  }

  getUser() {
    const userInfo = this.getUserInfo();
    return userInfo?.user || userInfo || null;
  }
}

const authService = new AuthService();
export default authService;